import '.aw{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.gu{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.c0{align-items:flex-start;}.ssr-plugin'
import '.cm{padding:2rem;}.ssr-plugin'
import '.d1{background:var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.b1{position:absolute;}.ssr-plugin'
import '.ip{top:50%;}.ssr-plugin'
import '.iq{right:1rem;}.ssr-plugin'
import '.ir{transform:translateY(-50%);}.ssr-plugin'
import '.is{width:120px;}.ssr-plugin'
import '.it{height:120px;}.ssr-plugin'
import '.iu{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.i3{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.iv{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="aw n gu d e at c0 cm d1 ag"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b1 ip iq ir is it iu d r at"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="aw i3 d e c0 s iv"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
